// src/components/landing/LandingPageHeader.jsx
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Row, Col, Button, Drawer, Grid } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import { NavLink } from "react-router-dom";

/**
 * Landing page header — uses images from public/images/
 * Files expected:
 *   public/images/PSGIAS_Logo.png
 *   public/images/logo_psg.png
 */

/**const NAV = [
  { key: "about", label: "About", to: "/about" },
  { key: "events", label: "Events", to: "/events" },
  { key: "insights", label: "Insights", to: "/insights" },
]; */

export default function LandingPageHeader({ brand = "PSG IAS Alumni" }) {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const screens = Grid.useBreakpoint();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const linkStyle = {
    color: "#333",
    textDecoration: "none",
    padding: "8px 12px",
    display: "inline-block",
    fontWeight: 500,
  };

  const activeLinkStyle = { color: "#0b5cff" };

  return (
    <>
      <style>{`
        .landing-header { position: sticky; top: 0; z-index: 60; background: #fff; transition: box-shadow 200ms ease, backdrop-filter 200ms ease; }
        .landing-header.scrolled { box-shadow: 0 6px 18px rgba(15, 23, 42, 0.06); }
        .landing-container { max-width: 1200px; margin: 0 auto; padding: 12px 20px; }
        .landing-logo { display:flex; align-items:center; gap:12px; }
        .landing-nav { display:flex; gap:8px; align-items:center; justify-content:center; }
        .landing-drawer .ant-drawer-wrapper-body { animation: fadeIn 220ms ease; }
        @keyframes fadeIn { from { opacity: 0; transform: translateY(6px);} to { opacity: 1; transform: translateY(0);} }
        @media (max-width: 767px) {
          .landing-center { display: none; }
        }
      `}</style>

      <header className={`landing-header ${scrolled ? "scrolled" : ""}`}>
        <div className="landing-container">
          <Row align="middle" justify="space-between">
            {/* LEFT: logo (served from public/images) */}
            <Col flex="0 1 auto" style={{ display: "flex", alignItems: "center" }}>
              <NavLink to="/" className="landing-logo" aria-label="Home">
                <img
                  src="https://www.psgias.ac.in/wp-content/uploads/2025/02/logo-dark-bg-148x69.png"
                  alt={`${brand} logo`}
                  style={{ height: 60 }}
                  loading="lazy"
                />
              </NavLink>
            </Col>

            {/* CENTER: nav links (currently commented out) */}
            {/*
            <Col flex="1 1 auto" className="landing-center">
              <nav className="landing-nav" aria-label="Main navigation">
                {NAV.map((n) => (
                  <NavLink
                    key={n.key}
                    to={n.to}
                    style={({ isActive }) => ({ ...linkStyle, ...(isActive ? activeLinkStyle : {}) })}
                  >
                    {n.label}
                  </NavLink>
                ))}
              </nav>
            </Col>
            */}

            {/* RIGHT: menu icon on small screens + right logo */}
            <Col flex="0 1 auto" style={{ display: "flex", alignItems: "center", gap: 12 }}>
              {!screens.md && (
                <Button
                  type="text"
                  icon={<MenuOutlined style={{ fontSize: 20 }} />}
                  onClick={() => setDrawerOpen(true)}
                  aria-label="Open menu"
                />
              )}

              <div style={{ display: "flex", alignItems: "center" }}>
                <img
                  src="https://www.psgsonscharities.org/images/100yearsLogo.png"
                  alt="PSG IAS"
                  style={{ height: 60 }}
                  loading="lazy"
                />
              </div>
            </Col>
          </Row>
        </div>
      </header>

      {/* Mobile Drawer (NAV logic commented out) */}
      <Drawer
        className="landing-drawer"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        placement="right"
        bodyStyle={{ padding: 20 }}
        closeIcon={null}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <NavLink
            to="/"
            onClick={() => setDrawerOpen(false)}
            style={{ display: "flex", gap: 12, alignItems: "center" }}
          >
            <img src="/images/logo_psg.png" alt="PSG IAS Alumni" style={{ height: 40 }} />
          </NavLink>

          {/*
          <nav style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            {NAV.map((n) => (
              <NavLink key={n.key} to={n.to} onClick={() => setDrawerOpen(false)} style={{ ...linkStyle }}>
                {n.label}
              </NavLink>
            ))}
          </nav>
          */}
        </div>
      </Drawer>
    </>
  );
}

LandingPageHeader.propTypes = {
  brand: PropTypes.string,
};
